import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

export default function ToyyibpayResult() {
  const loc = useLocation();
  const nav = useNavigate();
  const params = new URLSearchParams(loc.search);
  const billcode = params.get("billcode") || "";
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!billcode) return;
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/toyyibpay/status/${billcode}`);
        if (stop) return;
        setStatus(data);
        if (data.payment_status === "pending" && tries < 15) {
          setTimeout(() => setTries((n) => n + 1), 2000);
        }
      } catch {
        // ignore polling errors
      }
    };
    poll();
    return () => { stop = true; };
  }, [billcode, tries]);

  const paid = status.payment_status === "paid";
  const failed = status.payment_status === "failed";
  const Icon = paid ? CheckCircle2 : failed ? XCircle : Clock;
  const color = paid ? "text-primary bg-primary/10" : failed ? "text-destructive bg-destructive/10" : "text-muted-foreground bg-muted";

  return (
    <div className="min-h-screen grid place-items-center p-6 grain-bg">
      <Card className="w-full max-w-lg rounded-2xl" data-testid="toyyib-result">
        <CardContent className="p-8 text-center">
          <div className={`mx-auto mb-4 grid h-14 w-14 place-items-center rounded-2xl ${color}`}>
            <Icon className="h-7 w-7" />
          </div>
          <h1 className="font-display text-3xl font-bold">
            {paid ? "Payment received" : failed ? "Payment failed" : "Confirming payment…"}
          </h1>
          {status.package_name && <p className="mt-2 text-muted-foreground">{status.package_name}</p>}
          {status.amount != null && (
            <div className="mt-4 num text-4xl font-semibold" data-testid="toyyib-amount">
              {(status.currency || "MYR").toUpperCase()} {Number(status.amount).toFixed(2)}
            </div>
          )}
          <div className="mt-1 num text-xs text-muted-foreground">Bill: {billcode}</div>
          <div className="mt-6 flex justify-center gap-2">
            <Button onClick={() => nav("/parent/payments")} className="rounded-full h-11" data-testid="toyyib-back">
              Back to payments
            </Button>
            {!paid && !failed && (
              <Button variant="outline" onClick={() => setTries((n) => n + 1)} className="rounded-full h-11">
                Refresh
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
